import React from 'react'
import DirectoryNavbar from "../Components/navbar/DirectoryNavbar.jsx"

function competition() {
  return (
    <div>
      <DirectoryNavbar />
      COMING SOON!
    </div>
  )
}

export default competition
